import { useGenericQuery } from '../../../core/api/reactQuery';
import { getPractice } from '../queries';
import { practiceDetailStore } from '../stores/practiceDetailsStore';

export function useGetPracticesDetail(id: string) {
  const { setPractice } = practiceDetailStore();
  const {
    data,
    isError,
    error,
    isSuccess,
    isPending
  } = useGenericQuery(['practiceDetail', id], () => getPractice(id), setPractice);

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
  }
}
